var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v(" ASSOCIATION OF HEALTH MAINTENANCE ORGANIZATIONS OF THE PHILIPPINES, INC. (AHMOPI) ")]),_c('h4',[_vm._v(" A legal entity and the recognized organization in the country that ensures the professional conduct of Health Maintenance Organizations of the Philippines. ")])])
}]

export { render, staticRenderFns }